<ng-container *transloco="let t">
    <form
        [formGroup]="personalInformation"
        #ngForm="ngForm"
        fxLayout="column"
        (ngSubmit)="onSubmit($event)"
    >
        <h3>{{ t("shared.group.student-information") }}</h3>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="birthDate"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.birthdate") }}</mat-label>
                    <input
                        matInput
                        [matDatepicker]="birthdatePicker"
                        formControlName="birthDate"
                        [autocomplete]="'birthDate' | autocomplete"
                        maxlength="10"
                        (dateChange)="setAgeAtEnrollment(birthDate)"
                        [required]="birthDate.hasError('required')"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="birthdatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #birthdatePicker></mat-datepicker>
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-error *ngIf="birthDate?.hasError('required')"
                        >{{ t("shared.error.required.birthdate") }}
                    </mat-error>
                    <mat-error *ngIf="birthDate?.hasError('minimumAge')"
                        >{{ t("shared.error.min.age") }}
                    </mat-error>
                    <mat-error *ngIf="birthDate?.hasError('maximumAge')"
                        >{{ t("shared.error.max.age") }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="ageAtEnrollment"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.age") }}</mat-label>
                    <input
                        matInput
                        readonly
                        formControlName="ageAtEnrollment"
                        [autocomplete]="'ageAtEnrollment' | autocomplete"
                        type="number"
                        [required]="ageAtEnrollment.hasError('required')"
                    />
                    <mat-error *ngIf="ageAtEnrollment?.hasError('required')">
                        {{ t("shared.error.required.age-at-enrollment") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="firstName"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t("shared.field.legal-first-name")
                    }}</mat-label>
                    <input
                        matInput
                        formControlName="firstName"
                        [autocomplete]="'firstName' | autocomplete"
                        maxlength="50"
                        [required]="firstName.hasError('required')"
                    />
                    <mat-error *ngIf="firstName?.hasError('required')"
                        >{{ t("shared.error.required.legal-first-name") }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="middleName"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.middle-name") }}</mat-label>
                    <input
                        matInput
                        formControlName="middleName"
                        [autocomplete]="'middleName' | autocomplete"
                        maxlength="50"
                        [required]="middleName.hasError('required')"
                    />
                    <mat-error *ngIf="middleName?.hasError('pattern')"
                        >{{ t("shared.error.pattern.middle-name") }}
                    </mat-error>
                    <mat-error *ngIf="middleName?.hasError('required')">
                        {{ t("shared.error.required.middle-name") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="lastName"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.last-name") }}</mat-label>
                    <input
                        matInput
                        formControlName="lastName"
                        [autocomplete]="'lastName' | autocomplete"
                        maxlength="50"
                        [required]="lastName.hasError('required')"
                    />
                    <mat-error *ngIf="lastName?.hasError('required')">{{
                        t("shared.error.required.last-name")
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="suffix"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.suffix") }}</mat-label>
                    <input
                        matInput
                        formControlName="suffix"
                        [autocomplete]="'suffix' | autocomplete"
                        maxlength="10"
                        [required]="suffix.hasError('required')"
                    />
                    <mat-error *ngIf="suffix?.hasError('required')">
                        {{ t("shared.error.required.suffix") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="otherNames"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.other-name") }}</mat-label>
                    <input
                        matInput
                        formControlName="otherNames"
                        [autocomplete]="'otherNames' | autocomplete"
                        maxlength="200"
                        [required]="otherNames.hasError('required')"
                    />
                    <mat-error *ngIf="otherNames?.hasError('required')">
                        {{ t("shared.error.required.other-names") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="hasSocialSecurityNumberSelectionId"
                fxFlex="100"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    class="full-width"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="
                        hasSocialSecurityNumberSelections$
                            | async as hasSocialSecurityNumberSelections
                    "
                >
                    <mat-label>{{ t("shared.field.has-ssn") }}</mat-label>
                    <mat-select
                        formControlName="hasSocialSecurityNumberSelectionId"
                        [required]="
                            hasSocialSecurityNumberSelectionId.hasError(
                                'required'
                            )
                        "
                    >
                        <mat-option
                            *ngFor="
                                let hasSocialSecurityNumberSelection of hasSocialSecurityNumberSelections
                            "
                            [value]="
                                hasSocialSecurityNumberSelection.selectionId
                            "
                        >
                            {{ hasSocialSecurityNumberSelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            hasSocialSecurityNumberSelectionId?.hasError(
                                'required'
                            )
                        "
                        >{{ t("shared.error.required.has-ssn") }}</mat-error
                    >
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="socialSecurityNumber"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.ssn") }}</mat-label>
                    <app-ssn-input
                        formControlName="socialSecurityNumber"
                        #ssn
                        [required]="
                            hasSocialSecurityNumberSelectionId?.value === 419 ||
                            ssnRequired
                        "
                    ></app-ssn-input>
                    <mat-error
                        *ngIf="
                            !socialSecurityNumber?.hasError('required') &&
                            ssn.errorState
                        "
                        >{{ t("shared.error.pattern.ssn") }}
                    </mat-error>
                    <mat-error
                        *ngIf="socialSecurityNumber?.hasError('required')"
                    >
                        {{ t("shared.error.required.ssn") }}
                    </mat-error>
                    <mat-hint>###-##-####</mat-hint>
                </mat-form-field>
            </div>
            <div
                *ngIf="sexSelectionId"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="sexSelections$ | async as sexSelections"
                >
                    <mat-label>{{ t("shared.field.sex") }}</mat-label>
                    <mat-select
                        formControlName="sexSelectionId"
                        [required]="sexSelectionId.hasError('required')"
                    >
                        <mat-option
                            *ngFor="let sexSelection of sexSelections"
                            [value]="sexSelection.selectionId"
                        >
                            {{ sexSelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="sexSelectionId?.hasError('required')">{{
                        t("shared.error.required.sex")
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="sexBinarySelectionId"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="sexBinarySelections$ | async as sexBinarySelections"
                >
                    <mat-label>{{ t("shared.field.sex") }}</mat-label>
                    <mat-select
                        formControlName="sexBinarySelectionId"
                        [required]="sexBinarySelectionId.hasError('required')"
                    >
                        <mat-option
                            *ngFor="
                                let sexBinarySelection of sexBinarySelections
                            "
                            [value]="sexBinarySelection.selectionId"
                        >
                            {{ sexBinarySelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="sexBinarySelectionId?.hasError('required')"
                        >{{ t("shared.error.required.sex") }}</mat-error
                    >
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="socialSecurityNumber">
            <mat-error
                *ngIf="
                    socialSecurityNumber?.touched &&
                    socialSecurityNumber?.hasError('required')
                "
                style="margin-bottom: 20px"
            >
                {{ t("shared.error.required.ssn-instruction") }}
            </mat-error>
        </div>
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
            class="flyout-container"
        ></div>
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
            class="flyout-container"
        >
            <div
                *ngIf="genderIdentitySelectionId"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="
                        genderIdentitySelections$
                            | async as genderIdentitySelections
                    "
                >
                    <mat-label>{{
                        t("shared.field.gender-identity")
                    }}</mat-label>
                    <mat-select
                        formControlName="genderIdentitySelectionId"
                        [required]="
                            genderIdentitySelectionId.hasError('required')
                        "
                    >
                        <mat-option
                            *ngFor="
                                let genderIdentitySelection of genderIdentitySelections
                            "
                            [value]="genderIdentitySelection.selectionId"
                        >
                            {{ genderIdentitySelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="genderIdentitySelectionId?.hasError('required')"
                        >{{
                            t("shared.error.required.gender-identity")
                        }}</mat-error
                    >
                </mat-form-field>
            </div>
            <div
                *ngIf="pronounsSelectionId"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="pronounSelections$ | async as pronounSelections"
                >
                    <mat-label>{{ t("shared.field.pronouns") }}</mat-label>
                    <mat-select
                        formControlName="pronounsSelectionId"
                        [required]="pronounsSelectionId.hasError('required')"
                    >
                        <mat-option
                            *ngFor="let pronounSelection of pronounSelections"
                            [value]="pronounSelection.selectionId"
                        >
                            {{ pronounSelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="pronounsSelectionId?.hasError('required')"
                        >{{ t("shared.error.required.pronouns") }}</mat-error
                    >
                </mat-form-field>
            </div>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip height-auto visible-longer"
                [ngClass]="{
                    hidden: t('flyout.referral-source').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.gender-contact')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
        <div
            *ngIf="canContactByTextSelectionId"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div
                fxFlex="100"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    class="full-width"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="
                        canContactByTextSelections$
                            | async as canContactByTextSelections
                    "
                >
                    <mat-label>{{
                        t("shared.field.can-contact-by-text")
                    }}</mat-label>
                    <mat-select
                        formControlName="canContactByTextSelectionId"
                        [required]="
                            canContactByTextSelectionId.hasError('required')
                        "
                    >
                        <mat-option
                            *ngFor="
                                let canContactByTextSelection of canContactByTextSelections
                            "
                            [value]="canContactByTextSelection.selectionId"
                        >
                            {{ canContactByTextSelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            canContactByTextSelectionId?.hasError('required')
                        "
                        >{{
                            t("shared.error.required.can-contact-by-text")
                        }}</mat-error
                    >
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="mobilePhone"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.mobile-phone") }}</mat-label>
                    <app-phone-input
                        formControlName="mobilePhone"
                        #mobilePhone
                        [required]="
                            this.contactPreferenceSelectionId?.value === 17 ||
                            this.contactPreferenceSelectionId?.value === 19 ||
                            this.canContactByTextSelectionId?.value === 421 ||
                            mobilePhoneRequired
                        "
                    ></app-phone-input>
                    <mat-error
                        *ngIf="
                            !mobilePhone?.hasError('pattern') &&
                            mobilePhone?.hasError('required')
                        "
                        >{{
                            t("shared.error.required.mobile-phone")
                        }}</mat-error
                    >
                    <mat-error *ngIf="mobilePhone?.hasError('pattern')">{{
                        t("shared.error.pattern.phone")
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="homePhone"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.home-phone") }}</mat-label>
                    <app-phone-input
                        formControlName="homePhone"
                        #homePhone
                        [required]="
                            this.contactPreferenceSelectionId?.value === 15 ||
                            homePhoneRequired
                        "
                    ></app-phone-input>
                    <mat-error
                        *ngIf="
                            !homePhone?.hasError('pattern') &&
                            homePhone?.hasError('required')
                        "
                        >{{ t("shared.error.required.home-phone") }}</mat-error
                    >
                    <mat-error *ngIf="homePhone?.hasError('pattern')">{{
                        t("shared.error.pattern.phone")
                    }}</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="workPhone"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.work-phone") }}</mat-label>
                    <app-phone-input
                        formControlName="workPhone"
                        [showExtension]="true"
                        #workPhone
                        [required]="
                            this.contactPreferenceSelectionId?.value === 16 ||
                            workPhoneRequired
                        "
                    ></app-phone-input>
                    <mat-error
                        *ngIf="
                            !workPhone?.hasError('pattern') &&
                            workPhone?.hasError('required')
                        "
                        >{{ t("shared.error.required.work-phone") }}</mat-error
                    >
                    <mat-error *ngIf="workPhone?.hasError('pattern')">{{
                        t("shared.error.pattern.phone")
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="contactPreferenceSelectionId"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="
                        contactPreferenceSelections$
                            | async as contactPreferenceSelections
                    "
                >
                    <mat-label>{{
                        t("shared.field.contact-preference")
                    }}</mat-label>
                    <mat-select
                        formControlName="contactPreferenceSelectionId"
                        [required]="
                            contactPreferenceSelectionId.hasError('required')
                        "
                    >
                        <mat-option
                            *ngFor="
                                let contactPreferenceSelection of contactPreferenceSelections
                            "
                            [value]="contactPreferenceSelection.selectionId"
                        >
                            {{ contactPreferenceSelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="
                            contactPreferenceSelectionId?.hasError('required')
                        "
                        >{{
                            t("shared.error.required.contact-preference")
                        }}</mat-error
                    >
                </mat-form-field>
            </div>
        </div>
        <div>
            <mat-error
                *ngIf="
                    (mobilePhone?.touched ||
                        homePhone?.touched ||
                        workPhone?.touched) &&
                    personalInformation?.hasError('atLeastOnePhoneRequired')
                "
                style="margin-bottom: 20px"
                >{{ t("shared.error.required.one-phone") }}</mat-error
            >
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="email"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.email") }}</mat-label>
                    <input
                        matInput
                        type="email"
                        formControlName="email"
                        [autocomplete]="'email' | autocomplete"
                        maxlength="200"
                        [required]="email.hasError('required')"
                    />
                    <mat-error *ngIf="email?.hasError('required')">{{
                        t("shared.error.required.email")
                    }}</mat-error>
                    <mat-error *ngIf="email?.hasError('email')">{{
                        t("shared.error.email")
                    }}</mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="secondaryEmail"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t("shared.field.secondary-email")
                    }}</mat-label>
                    <input
                        matInput
                        type="email"
                        formControlName="secondaryEmail"
                        [autocomplete]="'email' | autocomplete"
                        maxlength="200"
                        [required]="secondaryEmail.hasError('required')"
                    />
                    <mat-error *ngIf="secondaryEmail?.hasError('required')">{{
                        t("shared.error.required.secondary-email")
                    }}</mat-error>
                    <mat-error *ngIf="secondaryEmail?.hasError('email')">{{
                        t("shared.error.email")
                    }}</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="consentReceiveTextMessage"
                fxFlex="100"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-checkbox
                    [checked]="consentReceiveTextMessage.value === 1"
                    (change)="onConsentReceiveTextMessageChange($event.checked)"
                >
                    {{ t("shared.field.consent-receive-text-message") }}
                </mat-checkbox>
                <mat-error
                    *ngIf="
                        personalInformation?.hasError(
                            'consentTextMessageRequired'
                        )
                    "
                    style="margin-bottom: 20px"
                    >{{
                        t("shared.error.required.consent-receive-text-message")
                    }}
                </mat-error>
            </div>
        </div>

        <h3 *ngIf="mailingAddress">
            {{ t("shared.group.mailing-address") }}
        </h3>
        <div *ngIf="mailingAddress" formGroupName="mailingAddress">
            <div
                *ngIf="streetAddress"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{
                            t("shared.field.address-line-1")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="streetAddress"
                            [autocomplete]="'streetAddress' | autocomplete"
                            maxlength="200"
                            [required]="streetAddress.hasError('required')"
                        />
                        <mat-error *ngIf="streetAddress?.hasError('required')">
                            {{ t("shared.error.required.address-line-1") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div
                *ngIf="aptSuiteOther"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{
                            t("shared.field.address-line-2")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="aptSuiteOther"
                            [autocomplete]="'aptSuiteOther' | autocomplete"
                            maxlength="200"
                            [required]="aptSuiteOther.hasError('required')"
                        />
                        <mat-error *ngIf="aptSuiteOther?.hasError('required')">
                            {{ t("shared.error.required.address-line-2") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    *ngIf="city"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{ t("shared.field.city") }}</mat-label>
                        <input
                            matInput
                            formControlName="city"
                            [autocomplete]="'city' | autocomplete"
                            maxlength="200"
                            [required]="city.hasError('required')"
                        />
                        <mat-error *ngIf="city?.hasError('required')">
                            {{ t("shared.error.required.city") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div
                    *ngIf="stateCode"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="stateSelections$ | async as stateSelections"
                    >
                        <mat-label>{{ t("shared.field.state") }}</mat-label>
                        <mat-select
                            formControlName="stateCode"
                            [required]="stateCode.hasError('required')"
                        >
                            <mat-option
                                *ngFor="let stateSelection of stateSelections"
                                [value]="stateSelection.code"
                            >
                                {{ stateSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="stateCode?.hasError('required')">
                            {{ t("shared.error.required.state-code") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    *ngIf="postalCode"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.postal-code")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="postalCode"
                            [autocomplete]="'postalCode' | autocomplete"
                            maxlength="20"
                            [required]="postalCode.hasError('required')"
                            inputmode="numeric"
                        />
                        <mat-error *ngIf="postalCode?.hasError('required')">
                            {{ t("shared.error.required.postal-code") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div
                    *ngIf="county"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{ t("shared.field.county") }}</mat-label>
                        <input
                            matInput
                            formControlName="county"
                            [autocomplete]="'county' | autocomplete"
                            maxlength="200"
                            [required]="county.hasError('required')"
                        />
                        <mat-error *ngIf="county?.hasError('required')">
                            {{ t("shared.error.required.county") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div
            *ngIf="mailingAddress"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div
                *ngIf="residenceAreaCode"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field
                    appearance="outline"
                    [floatLabel]="floatLabelControl.value"
                    *ngIf="
                        residenceAreaSelections$
                            | async as residenceAreaSelections
                    "
                >
                    <mat-label>{{
                        t("shared.field.residence-area")
                    }}</mat-label>
                    <mat-select
                        formControlName="residenceAreaCode"
                        [required]="residenceAreaCode.hasError('required')"
                    >
                        <mat-option
                            *ngFor="
                                let residenceAreaSelection of residenceAreaSelections
                            "
                            [value]="residenceAreaSelection.selectionId"
                        >
                            {{ residenceAreaSelection.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="residenceAreaCode?.hasError('required')">
                        {{ t("shared.error.required.residence-area-code") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <h3
            *ngIf="
                emergencyContactName ||
                emergencyContactPhone ||
                emergencyContactRelationship
            "
        >
            {{ t("shared.group.emergency-information") }}
        </h3>

        <p
            *ngIf="
                (emergencyContactName ||
                    emergencyContactPhone ||
                    emergencyContactRelationship) &&
                emergencyContactHeader
            "
            style="
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                margin-top: 0px;
            "
            innerHTML="{{ emergencyContactHeader }}"
        ></p>

        <div
            *ngIf="emergencyContactName"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div
                fxFlex="100"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{
                        t("shared.field.emergency-contact-name")
                    }}</mat-label>
                    <input
                        matInput
                        formControlName="emergencyContactName"
                        [autocomplete]="'emergencyContactName' | autocomplete"
                        maxlength="100"
                        [required]="emergencyContactName.hasError('required')"
                    />
                    <mat-error
                        *ngIf="emergencyContactName?.hasError('required')"
                    >
                        {{ t("shared.error.required.emergency-contact-name") }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div
                *ngIf="emergencyContactPhone"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t("shared.field.emergency-contact-phone")
                    }}</mat-label>
                    <app-phone-input
                        formControlName="emergencyContactPhone"
                        #emergencyContactPhone
                        [required]="emergencyPhoneRequired"
                    ></app-phone-input>
                    <mat-error
                        *ngIf="emergencyContactPhone?.hasError('pattern')"
                        >{{ t("shared.error.pattern.phone") }}</mat-error
                    >
                    <mat-error
                        *ngIf="emergencyContactPhone?.hasError('required')"
                    >
                        {{ t("shared.error.required.emergency-contact-phone") }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div
                *ngIf="emergencyContactRelationship"
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{
                        t("shared.field.emergency-contact-relationship")
                    }}</mat-label>
                    <input
                        matInput
                        formControlName="emergencyContactRelationship"
                        [autocomplete]="
                            'emergencyContactRelationship' | autocomplete
                        "
                        maxlength="100"
                        [required]="
                            emergencyContactRelationship.hasError('required')
                        "
                    />
                    <mat-error
                        *ngIf="
                            emergencyContactRelationship?.hasError('required')
                        "
                    >
                        {{
                            t(
                                "shared.error.required.emergency-contact-relationship"
                            )
                        }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="computerEquipmentSelectionIds">
            <app-multi-selection-control
                *ngIf="
                    computerEquipmentSelections$
                        | async as computerEquipmentSelections
                "
                [formGroup]="personalInformation"
                [selections]="computerEquipmentSelections"
                [control]="computerEquipmentSelectionIds"
                formControlName="computerEquipmentSelectionIds"
                [header]="t('shared.group.computer-equipment')"
                [label]="t('shared.radio-checkbox-group.computer-equipment')"
                [requiredMessage]="
                    t('shared.error.required.computer-equipment')
                "
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-error
                *ngIf="
                    personalInformation?.hasError(
                        'computerEquipmentNoneInvalid'
                    )
                "
                style="margin-bottom: 20px"
                >{{
                    t("shared.error.required.computer-equipment-none-invalid")
                }}
            </mat-error>
        </div>

        <button
            mat-stroked-button
            class="submit"
            type="submit"
            [disabled]="submitting"
        >
            {{ t("application.save-and-continue") }}
        </button>
    </form>
</ng-container>
